import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import CustomSelect from "../../components/customSelect";
import Table from "../../components/table";
import { publicSchoollistColumn } from "../../v2/utility/publicSchoolList";
import classes from "./styles.module.scss";
import Button from "../../components/buttonPrimary";
import * as APIs from "../../pages/registrationPage/apis";
import { hideLoader, notifyError, showLoader } from "../../components/loader";
import LoginFooter from "../loginContainer/loginFooter";
import LoginHeader from "../loginContainer/loginHeader";
import BreadcrumbComponent from "../../websiteComponents/breadcrumbComponent";
const PublicSchoolcontainer = () => {
  const [districtDropDown, setDistrictDropDown] = useState([]);
  const [allBlock, setAllBlock] = useState([]);

  const [state, setState] = useState({
    district: "",
    block: "",
  });

  const [allSchool, setAllSchool] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await APIs.getMasterData({
        tablesName: ["master_district"],
      });
      if (res.status) {
        setDistrictDropDown(res.data);
      }
    };
    fetchData();
  }, []);

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (state.district) {
      const getData = async () => {
        let res = await APIs.getCustoDropdown({
          dropdown_code: "block_master",
          districtId: [state.district],
        });
        setAllBlock(res.data);
      };
      getData();
    }
  }, [state.district]);

  const schoolTypeOptions = [
    { label: "Co-Educational", value: 1 },
    { label: "Boys School", value: 2 },
    { label: "Girls School", value: 3 },
  ];

  const mediumOptions = [
    { label: "Hindi", value: 1 },
    { label: "English", value: 2 },
    { label: "Both Hindi and English", value: 3 },
  ];

  const onDistrictOrBlock = async (districtId, blockId) => {
    if (!districtId) {
      notifyError("Please select District");
      return;
    } else if (!blockId) {
      notifyError("Please select Block");
      return;
    }

    showLoader();

    if (districtId && blockId) {
      let res = await APIs.getCustoDropdown({
        dropdown_code: "school_master",
        districtId: [districtId],
        blockId: [blockId],
      });

      if (res.status) {
        const mappedData = res.data.map((d, index) => {
          const approved = d?.approvedSchoolDetails || null;
          const schoolTypeLabel = approved?.schoolType
            ? approved.schoolType
            : schoolTypeOptions.find(opt => opt.value === Number(d?.schoolType))
                ?.label || "N/A";

          const mediumLabel = approved?.mediumOfInstruction
            ? approved.mediumOfInstruction
            : mediumOptions.find(opt => opt.value === Number(d?.schoolMedium))
                ?.label || "N/A";

          return {
            s_n: index + 1,
            schoolName: d?.schoolName,
            schoolAddress1: d?.schoolAddress1,
            schoolType: schoolTypeLabel,
            schoolMedium: mediumLabel,
            boardOfEducation: approved?.boardOfEducation || "N/A",
            levelOfEducation: approved?.levelOfEducation || "N/A",
            highestClass: approved?.highestClass || "N/A",
            blockName: d?.blockName,
            districtName: d?.districtName,
            pinCode: d?.pinCode,
            schoolId: d?.schoolId,
          };
        });

        setAllSchool(mappedData);
        hideLoader();
      } else {
        hideLoader();
        notifyError("Failed to fetch school data");
      }
    }
  };
  return (
    <div className={classes.public_school_container}>
      <LoginHeader />
      <BreadcrumbComponent />

      <div className={classes.table_filter_wrapper}>
        <div className={classes.filter_section}>
          <div className={classes.filter_wrapper}>
            <CustomSelect
              options={districtDropDown?.masterDistrict}
              placeholder="Select District"
              onChange={e => handleChange(e)}
              name="district"
              optionLabel="name"
              optionValue={"id"}
              second_className={classes.dropdown_style}
            />
            <CustomSelect
              options={allBlock}
              placeholder="Select Block"
              onChange={e => handleChange(e)}
              name="block"
              optionLabel="blockName"
              second_className={classes.dropdown_style}
              optionValue={"blockId"}
            />
            <div className={classes.button_container}>
              <Button
                button_text="Search"
                variant="button_blue"
                onClick={() => onDistrictOrBlock(state.district, state.block)}
                second_className={classes.search_button_style}
              />
            </div>
          </div>
        </div>
        <div className={classes.table_section}>
          <Table columns={publicSchoollistColumn} rows={allSchool} />
        </div>
      </div>

      <LoginFooter />
    </div>
  );
};

export default PublicSchoolcontainer;
